'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import { Link } from 'react-router-dom';

import {FaSyncAlt} from "react-icons/fa";

import Alert from "react-bootstrap/Alert";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import TermUtils from '@uw-it-sis/lib-react/lib/TermUtils';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import Lists from '@uw-it-sis/lib-react/lib/Lists';
import SimpleState from '@uw-it-sis/lib-react/lib/SimpleState';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import {withRouter} from "@uw-it-sis/lib-react/lib/WithRouter";
import DocumentTitle from '@uw-it-sis/lib-react/lib/DocumentTitle';
import {isTrue} from "@uw-it-sis/lib-react/lib/Utils";

import RelatedLinks from "@uw-it-sis/lib-react-myplan/lib/RelatedLinks";

import registrationStore from './RegistrationStore';
import RegistrationDetails from './RegistrationDetails';
import IntendedGraduation from "../common/IntendedGraduation";

/**
 * Container for the registration page.
 */
class Registration extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = registrationStore;

        this.buildDoneComponent = this.buildDoneComponent.bind(this);
        this.handleRefreshDataClick = this.handleRefreshDataClick.bind(this);
        this.analyticsStore = appStore.getAnalyticsStore();
    }

    componentDidMount() {
        this.store.mount();
    }

    componentWillUnmount() {
        // Only need to unmount if we mounted in the first place
        if ( appStore.isStudent() || appStore.isAdviser() ) {
            this.store.unmount();
        }
    }

    /**
     * Click handler for data refresh button.
     */
    handleRefreshDataClick() {
        this.analyticsStore.addEvent("RegPrev-RefreshClick", {}, {});
        this.store.refreshRegistrationDetails();
    }

    buildDoneComponent() {
        // page display component
        let rootComponent;



        let termCalculateResult = this.store.calculateDisplayTerm(this.props.identifier);

        // The term id for which the current page is displaying
        let termId = termCalculateResult.termId;
        let isPublished = termCalculateResult.isPublished;
        let errorMsgs = termCalculateResult.errorMsgs;

        // Show error messaging if there are any
        if ( errorMsgs.length > 0 ) {
            rootComponent =
                <DocumentTitle title="MyPlan">
                    <Row>
                        <Col xs={12}>
                            <div className="page-heading">
                                <h1>Registration</h1>
                            </div>
                            <Alert variant="danger">
                                <Lists data={errorMsgs} unstyled />
                            </Alert>
                        </Col>
                    </Row>
                </DocumentTitle>;
        } else {
            let currentTerm = this.store.getCurrentTerm();
            let termLabel = "Upcoming";
            let srTermLabel = "Upcoming Quarter";
            if ( termId === currentTerm.id ) {
                let srTermLabel = "Current Quarter";
                if ( currentTerm.currentWeek > 0 ) {
                    termLabel = `Week ${currentTerm.currentWeek} of ${currentTerm.maxWeeks}`;
                } else {
                    termLabel = "Current";
                }
            }

            // Build a link back to academic year
            // the url path should look like /2019-20/su 
            // the link text should say "Academic Year 2019-2020"
            let quarterString = TermUtils.makeTermDescriptionFromTermId(termId, TermUtils.SIZE.SHORT).substring(0,2).toLowerCase();
            let yearLinkPath = '/' + TermUtils.getAcademicYearCode(termId, TermUtils.SIZE.MEDIUM) + '/' + quarterString;
            let yearLinkText = 'Academic Year ' + TermUtils.getAcademicYearCode(termId, TermUtils.SIZE.LONG);

            rootComponent =
                <DocumentTitle title={TermUtils.makeTermDescriptionFromTermId(termId) + " - MyPlan"}>
                    <>
                        <div className="page-heading d-flex align-items-end justify-content-between">
                            <div>
                                <div className="d-flex align-items-end">
                                    <h1 className="mb-0 fw-bold">{TermUtils.makeTermDescriptionFromTermId(termId)} <span className="sr-only">{srTermLabel}</span></h1>
                                    <Badge bg="light-gray" className="text-dark text-uppercase fw-normal border ms-2" aria-hidden={true}>{termLabel}</Badge>
                                </div>
                                <IntendedGraduation termId={termId} showText />
                                <div className="mt-2">
                                    <Link to={{pathname: yearLinkPath}}>{yearLinkText}</Link>
                                </div>
                            </div>
                            <Button variant="inline-link" size="sm" onClick={this.handleRefreshDataClick}>
                                <FaSyncAlt className="me-2" aria-hidden="true"/>
                                Refresh all
                            </Button>
                        </div>
                        <RegistrationDetails termId={termId} isPublished={isPublished} />
                    </>
                </DocumentTitle>;
        }

        return rootComponent;
    }

    render() {
        let relatedLinks = null;
        if (this.props.relatedLinks) {
            relatedLinks = <RelatedLinks links={this.props.relatedLinks} />;
        }

        let pageTitle;
        if ( this.store.state === States.pending ) {
            pageTitle =
                <div className="page-heading">
                </div>
        }

        return (
            <DocumentTitle title={"MyPlan"}>
                <>
                    {pageTitle}
                    <SimpleState state={this.store.state}
                                 doneComponentBuilder={this.buildDoneComponent}
                                 pendingComponentBuilder="dots"
                                 name="Registration"/>
                    {relatedLinks}
                </>
            </DocumentTitle>
        );
    }
}

Registration.propTypes = {
    identifier: PropTypes.string.isRequired,
    relatedLinks: PropTypes.array
};

export default withRouter(observer(Registration));